import { PUBLIC_BONUS_TRACKER_VIEW } from '../actions/types';

export const publicBonusTrackerGaActionEvents = {
  [PUBLIC_BONUS_TRACKER_VIEW]: ({ bonusId }) => ({
    category: 'Automatic Public: Extra Page Hero Banner',
    action: 'View',
    label: bonusId,
  }),
};
